import { Link } from 'react-router-dom';
import { classicArticles, latestArticles } from '@/mocks/articles';

const classicImages: Record<string, string> = {
  'classic-xingsaorao-2026': 'https://readdy.ai/api/search-image?query=A%20timeline%20of%20newspaper%20clippings%20pinned%20on%20a%20dark%20cork%20board%2C%20dramatic%20lighting%2C%20investigative%20journalism%20aesthetic%2C%20noir%20atmosphere%2C%20editorial%20photography&width=480&height=320&seq=classic-xingsaorao-2026&orientation=landscape',
  'classic-wanghong-2026': 'https://readdy.ai/api/search-image?query=Collapsed%20house%20of%20cards%20made%20of%20social%20media%20icons%2C%20dramatic%20lighting%2C%20metaphor%20for%20influencer%20downfall%2C%20dark%20background%2C%20editorial%20photography%2C%20cinematic%20composition&width=480&height=320&seq=classic-wanghong-2026&orientation=landscape',
  'classic-taoshui-2026': 'https://readdy.ai/api/search-image?query=A%20stack%20of%20tax%20documents%20under%20dramatic%20interrogation%20room%20lighting%2C%20dark%20atmosphere%2C%20investigative%20mood%2C%20film%20noir%20style%2C%20high%20contrast%2C%20editorial%20photography&width=480&height=320&seq=classic-taoshui-2026&orientation=landscape',
};

export default function ClassicSection() {
  const hotToday = latestArticles.slice(0, 4);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-16">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2">
          <div className="flex items-end justify-between mb-8">
            <div>
              <p className="text-sm font-medium text-accent-600 uppercase tracking-wider mb-2">经典回顾</p>
              <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-950">
                历年<span className="text-primary-500">大瓜合集</span>
              </h2>
            </div>
            <Link
              to="/category/li-nian-he-ji"
              className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="space-y-5">
            {classicArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group flex flex-col sm:flex-row gap-5 p-5 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full sm:w-48 h-32 flex-shrink-0 rounded-xl overflow-hidden">
                  <img
                    src={classicImages[article.imageSeq] || ''}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <span className="inline-block text-xs font-medium text-secondary-600 bg-secondary-100 px-2.5 py-1 rounded-full mb-2">
                    {article.category}
                  </span>
                  <h3 className="text-lg font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 line-clamp-2 mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {article.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views >= 10000 ? `${(article.views / 10000).toFixed(0)}万` : article.views}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div>
          <div className="sticky top-24">
            <div className="bg-background-100 rounded-2xl p-6 border border-background-200/70">
              <div className="flex items-center gap-2 mb-5">
                <i className="ri-fire-line text-accent-500 text-lg"></i>
                <h3 className="text-lg font-heading font-bold text-foreground-950">今日热度榜</h3>
              </div>
              <div className="space-y-4">
                {hotToday.map((article, index) => (
                  <Link
                    key={article.slug}
                    to={`/article/${article.slug}`}
                    className="flex items-start gap-3 group cursor-pointer"
                  >
                    <span className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${
                      index === 0 ? 'bg-accent-500 text-background-50' :
                      index === 1 ? 'bg-primary-500 text-background-50' :
                      'bg-secondary-200 text-secondary-700'
                    }`}>
                      {index + 1}
                    </span>
                    <div className="min-w-0">
                      <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2">
                        {article.title}
                      </p>
                      <span className="text-xs text-foreground-400 mt-1">
                        {article.views >= 10000 ? `${(article.views / 10000).toFixed(0)}万` : article.views} 次围观
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}